function IWStreetsPostProcessor(map, serverConfig, renderingConfig) {
  const mapType = new IWMapType(map);
  mapType.setName('streets');
  mapType.setRenderingConfig(this.cleanRenderingConfig(renderingConfig));
  mapType.setTilesServerConfig(serverConfig);
  this._factory = new IWVectorTileFactory(map, mapType);
}

IWStreetsPostProcessor.prototype = new IWTilePostProcessor();

IWStreetsPostProcessor.prototype.process = function (canvas, x, y, z) {
  this._factory.getJsonTile(z, x, y, function (trafficCanvas) {
    if (trafficCanvas) {
      let ctx = canvas.getContext('2d');
      ctx.drawImage(trafficCanvas, 0, 0);
    }
  });
};

IWStreetsPostProcessor.prototype.cleanRenderingConfig = function(renderingConfig) {
  renderingConfig.background = [{
    "from": 1,
    "to": 19,
    "color": "rgba(0, 0, 0, 0)"
  }];

  for (let layer in renderingConfig.layers) {
    let renderer = 	renderingConfig.renderers[layer];
    if (renderer) {
      for (let i = 0; i < renderer.length; i++) {
        if (renderer[i].polygon) {
          delete renderingConfig.layers[layer];
          delete renderingConfig.renderers[layer];
          break;
        }
      }
    }
  }

  return renderingConfig;
};
/*
IWStreetsPostProcessor.CONFIG = {
  "background": [
    {
      "from": 1,
      "to": 19,
      "color": "rgba(0, 0, 0, 0)"
    }
  ],
  "layers": {
    "country": "country",
    "highway": "highway",
    "interstate_major": "interstate_major",
    "interstate_minor": "interstate_minor",
    "minor_road": "minor_road",
    "minor_road_restricted": "minor_road_restricted",
    "minor_road_oneway": "minor_road_oneway",
    "minor_road_oneway_rev": "minor_road_oneway_reverse",
    "residential_road": "residential_road",
    "residential_road_oneway": "residential_road_oneway",
    "residential_road_oneway_rev": "residential_road_oneway_rev",
    "ferry": "ferry",
    "rail": "rail",
    "capital": "metropolis",
    "metropolis": "metropolis",
    "large_city": "large_city",
    "city": "city",
    "settlement": "settlement",
    "other_settlement": "settlement",
    "interstateNumbers": "interstateNumbers",
    "expresswayNumbers": "highway",
    "expresswayintersections": "interstate_minor",
    "trafficFlowFast": "trafficFlowFast",
    "trafficFlowMedium": "trafficFlowMedium",
    "trafficFlowSlow": "trafficFlowSlow",
    "trafficJam": "trafficJam",
    "roadworks": "roadworks",
    "dangerousSituation": "dangerous_situation",
    "accident": "dangerous_situation"
  },
  "renderers": {
    "metropolis": [
      {
        "from": 17,
        "to": 19,
        "text": {
          "size": 30,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "text": {
          "size": 24,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 3,
        "to": 14,
        "text": {
          "size": 20,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      }
    ],
    "large_city": [
      {
        "from": 17,
        "to": 19,
        "text": {
          "size": 24,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "text": {
          "size": 18,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 4,
        "to": 14,
        "text": {
          "size": 14,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      }
    ],
    "city": [
      {
        "from": 17,
        "to": 19,
        "text": {
          "size": 20,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 15,
        "text": {
          "size": 16,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 6,
        "to": 14,
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      }
    ],
    "settlement": [
      {
        "from": 17,
        "to": 19,
        "text": {
          "size": 18,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "text": {
          "size": 14,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 10,
        "to": 14,
        "text": {
          "size": 10,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      }
    ],
    "country": [
      {
        "from": 1,
        "to": 19,
        "line": {
          "color": "#acacac"
        },
        "text": {
          "size": 18,
          "color": "#606060",
          "font": "Open Sans",
          "fontWeight": "bold",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      }
    ],
    "trafficFlowFast": [
      {
        "from": 1,
        "to": 8,
        "line": {
          "color": "#50dc32",
          "width": 1
        }
      },
      {
        "from": 9,
        "to": 12,
        "line": {
          "color": "#50dc32",
          "width": 2
        }
      },
      {
        "from": 13,
        "to": 15,
        "line": {
          "color": "#50dc32",
          "width": 3
        }
      },
      {
        "from": 16,
        "to": 19,
        "line": {
          "color": "#50dc32",
          "width": 4
        }
      }
    ],
    "trafficFlowMedium": [
      {
        "from": 1,
        "to": 8,
        "line": {
          "color": "#ffa500",
          "width": 1
        }
      },
      {
        "from": 9,
        "to": 12,
        "line": {
          "color": "#ffa500",
          "width": 2
        }
      },
      {
        "from": 13,
        "to": 15,
        "line": {
          "color": "#ffa500",
          "width": 3
        }
      },
      {
        "from": 16,
        "to": 19,
        "line": {
          "color": "#ffa500",
          "width": 4
        }
      }
    ],
    "trafficFlowSlow": [
      {
        "from": 1,
        "to": 8,
        "line": {
          "color": "#c80000",
          "width": 1
        }
      },
      {
        "from": 9,
        "to": 12,
        "line": {
          "color": "#c80000",
          "width": 2
        }
      },
      {
        "from": 13,
        "to": 15,
        "line": {
          "color": "#c80000",
          "width": 3
        }
      },
      {
        "from": 16,
        "to": 19,
        "line": {
          "color": "#c80000",
          "width": 4
        }
      }
    ],
    "trafficJam": [
      {
        "from": 1,
        "to": 10,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 17,
          "height": 15,
          "dx": -8,
          "dy": -7
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 11,
        "to": 14,
        "image": {
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmlld0JveD0iMCAwIDg0Ny4xNTQ2IDc0My42MjUzNyIKICAgaGVpZ2h0PSI3NDMuNjI1MzciCiAgIHdpZHRoPSI4NDcuMTU0NiIKICAgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIKICAgdmVyc2lvbj0iMS4xIgogICBpZD0ic3ZnMjEzMzkiPjxtZXRhZGF0YQogICAgIGlkPSJtZXRhZGF0YTIxMzQ1Ij48cmRmOlJERj48Y2M6V29yawogICAgICAgICByZGY6YWJvdXQ9IiI+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUKICAgICAgICAgICByZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPjxkYzp0aXRsZT48L2RjOnRpdGxlPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48ZGVmcwogICAgIGlkPSJkZWZzMjEzNDMiIC8+PGcKICAgICB0cmFuc2Zvcm09Im1hdHJpeCgxLjI1LDAsMCwtMS4yNSwwLDc0My42MjUzNCkiCiAgICAgaWQ9ImcyMTM0NyI+PGcKICAgICAgIGlkPSJnMjEzNDkiPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMjEzNTEiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Im0gMzM4Ljg2Nyw1OTQuNTAyIGMgLTcuNTEyLDAgLTE1LjAyMywtMi44NjcgLTIwLjc1OCwtOC41OTggLTEuODgyLC0xLjg3OSAtMy40NDksLTMuOTUzIC00LjcxMSwtNi4xNTIgbCAtMTUuMjQ2LC0yNi4xNTYgLTAuMDY2LDAgTCA0Ljk4LDQ1LjU1MyBDIDQuOTMsNDUuNDU5IDQuODg3LDQ1LjM2NSA0LjgzMiw0NS4yNjQgMy4zNDgsNDIuODczIDIuMTc2LDQwLjIyMSAxLjM5OCwzNy4zNTMgLTIuNzg5LDIxLjY5NyA2LjUwNCw1LjU5OSAyMi4xNiwxLjQwNCBjIDIuNTksLTAuNjk1IDUuMTg4LC0xLjAxMiA3LjczOCwtMSBsIDYxOC4wNzUsMCBjIDE2LjIxMSwwIDI5LjM1MSwxMy4xNDEgMjkuMzUxLDI5LjM1NiAwLDUuMjk3IC0xLjQxOCwxMC4yODEgLTMuODc5LDE0LjU3OCAtMC4wMTksMC4wMzUgLTAuMDQzLDAuMDYyIC0wLjA1LDAuMDk3IEwgMzY5LjAyMyw1NzIuODQ2IGMgLTMuODYzLDYuNjY0IC01LjY0OCw5LjMwNCAtOS40MDIsMTMuMDU4IC01LjczLDUuNzMxIC0xMy4yNDIsOC41OTggLTIwLjc1NCw4LjU5OCB6IiAvPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMjEzNTMiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNjMTEyMWM7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Im0gMzM4Ljg2Nyw1ODcuMTQ2IGMgLTcuMTI1LDAuMDUxIC0xNC45NTMsLTMuNTkzIC0xOC43ODEsLTEwLjM5OCBMIDEwLjc4OSw0MC44NDkgQyA5LjAwOCwzNy4yMDEgOC4yNTgsMzQuMDI5IDguMjM0LDMwLjQgOC4yMzQsMjMuOTA0IDExLjEwNSwxNy43NCAxNi4wODIsMTMuNTUzIDIwLjQ2OSwxMC4xNjYgMjQuNjE3LDguNCAzMC4yMDMsOC40IGwgNjE3LjkwNiwwIGMgMy43NywtMC4wMzUgNy41NDMsMC44NzEgMTAuOTgxLDMuMTMzIDYuNDQxLDMuODk1IDEwLjM5OCwxMC44ODMgMTAuNDA2LDE4LjQyNiAtMC4xODQsMy44OTQgLTEuMTQ4LDggLTIuODc5LDEwLjg5IEwgMzU3LjUwNCw1NzYuODMgYyAtMC4wMzEsMC4wNDcgLTAuMDU5LDAuMDk0IC0wLjA5NCwwLjE0MSAtMC4wMjcsMC4wNDYgLTAuMDYyLDAuMDg2IC0wLjA5LDAuMTQ0IC0xLjA5NywxLjc1OCAtMi40NzIsMy4zMDUgLTQuMDQ3LDQuNjMzIC0zLjU4MiwzLjEwOSAtOC4wNzgsNC45NzYgLTEyLjgxNiw1LjMwOSAtMC41MzEsMC4wNTQgLTEuMDYyLDAuMDg1IC0xLjU5LDAuMDg5IHogTSAzMC4yMDMsOC40IGwgLTEuNTIzLDAgMS41NTQsMCAtMC4wMzEsMCB6IE0gMzM4LjU0Nyw0ODAuOTI4IDU3NC4yNSw3Mi40IGwgLTQ3MS43MzgsMCAyMzYuMDM1LDQwOC41MjggeiIgLz48cGF0aAogICAgICAgICBpZD0icGF0aDIxMzU1IgogICAgICAgICBzdHlsZT0iZmlsbDojMDAwMDAwO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpub25lIgogICAgICAgICBkPSJtIDMzOC44NjcsNTk0LjkgYyAtNy42MTcsMCAtMTUuMjMsLTIuOTA2IC0yMS4wMzksLTguNzIyIC0xLjkwNiwtMS44OTUgLTMuNDkyLC00LjAwNCAtNC43NzMsLTYuMjI3IGwgLTE1LjEyOSwtMjUuOTU3IC0wLjA3NCwwIEwgNC42NDEsNDUuNzU2IEMgNC41NzQsNDUuNjM5IDQuNTIzLDQ1LjUzNyA0LjQ3Nyw0NS40NTUgMi45NzMsNDMuMDMzIDEuNzk3LDQwLjM1MyAxLjAyLDM3LjQ1OSAtMy4yMywyMS41ODggNi4xOTEsNS4yNzEgMjIuMDU5LDEuMDE3IDI0LjY4LDAuMzE0IDI3LjMxNiwtMC4wMDYgMjkuODk4LDAuMDAyIGwgNjE4LjA3NSwwIGMgMTYuNDI1LDAgMjkuNzUsMTMuMzI4IDI5Ljc1LDI5Ljc1OCAwLDUuMzc1IC0xLjQzOCwxMC40MTQgLTMuOTM0LDE0Ljc3MyAtMC4wMTYsMC4wMTYgLTAuMDIzLDAuMDUxIC0wLjA0NywwLjA5OCBMIDM2OS4zNzksNTczLjA0NSBjIC0zLjg3MSw2LjY2OCAtNS42OTUsOS4zNjMgLTkuNDczLDEzLjEzMyAtNS44MDgsNS44MTYgLTEzLjQyNiw4LjcyMiAtMjEuMDM1LDguNzIyIGwgLTAuMDA0LDAgeiBtIDAsLTAuMzk4IGMgNy41MTIsMCAxNS4wMjQsLTIuODY3IDIwLjc1NCwtOC41OTggMy43NTQsLTMuNzU0IDUuNTM5LC02LjM5NCA5LjQwMiwtMTMuMDU4IEwgNjczLjM5MSw0NC40MzUgYyAwLjAxMSwtMC4wMzUgMC4wMzUsLTAuMDYyIDAuMDU0LC0wLjA5NyAyLjQ2MSwtNC4yOTcgMy44NzksLTkuMjgxIDMuODc5LC0xNC41NzggMCwtMTYuMjE1IC0xMy4xNCwtMjkuMzU2IC0yOS4zNTEsLTI5LjM1NiBsIC02MTguMDc1LDAgQyAyNy4zNDgsMC4zOTIgMjQuNzUsMC43MDkgMjIuMTYsMS40MDQgNi41MDQsNS41OTkgLTIuNzg5LDIxLjY5NyAxLjM5OCwzNy4zNTMgYyAwLjc3LDIuODY4IDEuOTUsNS41MiAzLjQzNCw3LjkxMSAwLjA1NSwwLjEwMSAwLjA5OCwwLjE5NSAwLjE0OCwwLjI4OSBsIDI5My4xMDYsNTA4LjA0MyAwLjA2NiwwIDE1LjI0NiwyNi4xNTYgYyAxLjI2MiwyLjE5OSAyLjgyOSw0LjI3MyA0LjcxMSw2LjE1MiA1LjczNSw1LjczMSAxMy4yMzksOC41OTggMjAuNzU4LDguNTk4IHoiIC8+PHBhdGgKICAgICAgICAgaWQ9InBhdGgyMTM1NyIKICAgICAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAzNTAuODk4LDE0OS4zODEgYyAwLDIuMzk0IDAuNzksNC43NDYgMi4yMjcsNi42NjQgbCAyLjIwMywyLjk1NyBjIDEuNTYzLDIuMDYyIDIuODcxLDQuMzEyIDMuODkxLDYuNjg3IGwgMTQuNjI5LDMzLjYzNyBjIDEuNDc2LDMuMzk1IDQuODA0LDUuNTYzIDguNDY4LDUuNTYzIGwgOTIuNDI2LDAgYyAzLjY4NCwwIDcuMDEyLC0yLjE2OCA4LjQ4OCwtNS41NjMgbCAxNC42MSwtMzMuNjM3IGMgMS4wMzksLTIuMzc1IDIuMzUxLC00LjYyNSAzLjg5LC02LjY4NyBsIDIuMjI3LC0yLjk1NyBjIDEuNDM0LC0xLjkxOCAyLjIyNywtNC4yNyAyLjIyNywtNi42NjQgbCAwLC0yNC4wNTkgYyAwLC01LjEwMSAtNC4xNDEsLTkuMjQ2IC05LjI2MiwtOS4yNDYgbCAtMTM2Ljc4NSwwIGMgLTUuMDk4LDAgLTkuMjM5LDQuMTQ1IC05LjIzOSw5LjI0NiBsIDAsMjQuMDU5IHogbSAxNy41NTksMTQuODA4IDEyMC4xNjQsMCAtMTIuNzE1LDI5LjIyMyBjIC0wLjU4MiwxLjM1MiAtMS45MTQsMi4yMjcgLTMuMzksMi4yMjcgbCAtODcuOTU0LDAgYyAtMS40NzYsMCAtMi44MDgsLTAuODc1IC0zLjM5LC0yLjIyNyBsIC0xMi43MTUsLTI5LjIyMyB6IG0gLTguMzIsLTUxLjgyIDIyLjE3OSwwIDAsLTIwLjM1MiBjIDAsLTMuMDU4IC0yLjQ3NiwtNS41MzkgLTUuNTM1LC01LjUzOSBsIC0xMS4wOSwwIGMgLTMuMDU4LDAgLTUuNTU0LDIuNDgxIC01LjU1NCw1LjUzOSBsIDAsMjAuMzUyIHogbSAxMTQuNjA1LDAgMjIuMTgsMCAwLC0yMC4zNTIgYyAwLC0zLjA1OCAtMi40NzMsLTUuNTM5IC01LjUzNSwtNS41MzkgbCAtMTEuMDksMCBjIC0zLjA1OSwwIC01LjU1NSwyLjQ4MSAtNS41NTUsNS41MzkgbCAwLDIwLjM1MiB6IiAvPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMjEzNTkiCiAgICAgICAgIHN0eWxlPSJmaWxsOiMwMDAwMDA7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Im0gMjg1Ljg5OCwyMDAuMzQyIGMgMCwyLjA0MyAwLjY2OCw0LjA0MyAxLjg5NSw1LjY4NyBsIDEuODk1LDIuNTIgYyAxLjMwOCwxLjc2OSAyLjQzMywzLjY2NCAzLjMwOCw1LjcwNyBsIDEyLjQ2MSwyOC42NiBjIDEuMjUsMi44NzUgNC4xMDIsNC43NDYgNy4yMjMsNC43NDYgbCA3OC43OTcsMCBjIDMuMTQsMCA1Ljk3MiwtMS44NzEgNy4yMTgsLTQuNzQ2IGwgMTIuNDY1LC0yOC42NiBjIDAuODk1LC0yLjA0MyAxLjk5NiwtMy45MzggMy4zMjgsLTUuNzA3IGwgMC45MzgsLTEuMjUgLTMzLjEwNiwwIGMgLTQuNjQsMCAtOC44MiwtMi43NSAtMTAuNjc1LC03IGwgLTEyLjMxNywtMjguMzQ0IC02NS41NDMsMCBjIC00LjM0NywwIC03Ljg4NywzLjUxOSAtNy44ODcsNy44OTEgbCAwLDIwLjQ5NiB6IG0gMTQuOTYxLDEyLjYyMSAxMDIuNDM0LDAgLTEwLjg0LDI0LjkxIGMgLTAuNSwxLjE0OCAtMS42MjEsMS44OTggLTIuODkxLDEuODk4IGwgLTc0Ljk2OCwwIGMgLTEuMjUsMCAtMi4zOTUsLTAuNzUgLTIuODk1LC0xLjg5OCBsIC0xMC44NCwtMjQuOTEgeiBtIC03LjA3NCwtNDQuMTc2IDE4Ljg5NSwwIDAsLTE3LjM0OCBjIDAsLTIuNjA1IC0yLjEwMiwtNC43MyAtNC43MjcsLTQuNzMgbCAtOS40NDUsMCBjIC0yLjYyMSwwIC00LjcyMywyLjEyNSAtNC43MjMsNC43MyBsIDAsMTcuMzQ4IHoiIC8+PHBhdGgKICAgICAgICAgaWQ9InBhdGgyMTM2MSIKICAgICAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAyMjguMTI1LDI0NS42NDIgYyAwLDEuNzI3IDAuNTU5LDMuNDE1IDEuNjAyLDQuODA5IGwgMS42MDEsMi4xMjUgYyAxLjEyNSwxLjUgMi4wNTksMy4xMjUgMi44MDksNC44MzIgbCAxMC41NTEsMjQuMjY2IGMgMS4wNTgsMi40MzcgMy40NTMsNCA2LjA5Myw0IGwgNjYuNjY4LDAgYyAyLjY2NCwwIDUuMDU1LC0xLjU2MyA2LjExNywtNCBsIDEwLjU1MSwtMjQuMjY2IGMgMC43NDYsLTEuNzA3IDEuNjg0LC0zLjMzMiAyLjgwOSwtNC44MzIgbCAxLjYwMSwtMi4xMjUgMC4yNSwtMC4zNzUgLTI2LjA5MywwIGMgLTQuMDk4LDAgLTcuODAxLC0yLjQzNCAtOS40MjYsLTYuMTg0IGwgLTkuNjc2LC0yMi4yODUgLTU4LjgwMSwwIGMgLTMuNjYsMCAtNi42NTYsMi45OTYgLTYuNjU2LDYuNjg0IGwgMCwxNy4zNTEgeiBtIDEyLjY3MiwxMC42ODQgODYuNjYsMCAtOS4xNzYsMjEuMDc4IGMgLTAuNDE0LDAuOTgxIC0xLjM3MSwxLjYwNiAtMi40MzMsMS42MDYgbCAtNjMuNDQyLDAgYyAtMS4wNjIsMCAtMi4wMTksLTAuNjI1IC0yLjQ1NywtMS42MDYgbCAtOS4xNTIsLTIxLjA3OCB6IG0gLTYuMDE2LC0zNy4zODcgMTYsMCAwLC0xNC42ODMgYyAwLC0yLjIwNyAtMS43ODksLTQgLTMuOTkyLC00IGwgLTcuOTkyLDAgYyAtMi4yMDMsMCAtNC4wMTYsMS43OTMgLTQuMDE2LDQgbCAwLDE0LjY4MyB6IiAvPjwvZz48L2c+PC9zdmc+",
          "width": 26,
          "height": 22,
          "dx": -13,
          "dy": -11
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 15,
        "to": 19,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 34,
          "height": 30,
          "dx": -17,
          "dy": -15
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      }
    ],
    "roadworks": [
      {
        "from": 1,
        "to": 10,
        "image": {
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmlld0JveD0iMCAwIDg0Ny4xNTg1NyA3NDMuNjIyNjgiCiAgIGhlaWdodD0iNzQzLjYyMjY4IgogICB3aWR0aD0iODQ3LjE1ODU3IgogICB4bWw6c3BhY2U9InByZXNlcnZlIgogICB2ZXJzaW9uPSIxLjEiCiAgIGlkPSJzdmc1NDg4Ij48bWV0YWRhdGEKICAgICBpZD0ibWV0YWRhdGE1NDk0Ij48cmRmOlJERj48Y2M6V29yawogICAgICAgICByZGY6YWJvdXQ9IiI+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUKICAgICAgICAgICByZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPjxkYzp0aXRsZT48L2RjOnRpdGxlPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48ZGVmcwogICAgIGlkPSJkZWZzNTQ5MiIgLz48ZwogICAgIHRyYW5zZm9ybT0ibWF0cml4KDEuMjUsMCwwLC0xLjI1LDAsNzQzLjYyMjY3KSIKICAgICBpZD0iZzU0OTYiPjxnCiAgICAgICBpZD0iZzU0OTgiPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoNTUwMCIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAzMzguODY3LDU5NC41IGMgLTcuNTEyLDAgLTE1LjAyNywtMi44NjcgLTIwLjc1OCwtOC41OTggLTEuODc5LC0xLjg3OSAtMy40NDUsLTMuOTUzIC00LjcwNywtNi4xNTIgbCAtMTUuMjQ2LC0yNi4xNTcgLTAuMDcsMCBMIDQuOTg0LDQ1LjU1NCBDIDQuOTMsNDUuNDU3IDQuODg3LDQ1LjM1OSA0LjgzMiw0NS4yNjEgMy4zNDQsNDIuODY3IDIuMTc2LDQwLjIxOCAxLjQwNiwzNy4zNTEgLTIuNzg5LDIxLjY5NSA2LjUwNCw1LjU5NyAyMi4xNjQsMS40MDIgYyAyLjU4NiwtMC42OTUgNS4xODQsLTEuMDEyIDcuNzM4LC0xIGwgNjE4LjA2NywwIGMgMTYuMjE1LDAgMjkuMzU1LDEzLjE0MSAyOS4zNTUsMjkuMzU2IDAsNS4zMDQgLTEuNDE0LDEwLjI4MSAtMy44NzksMTQuNTc4IC0wLjAxOSwwLjAzMSAtMC4wMzUsMC4wNjIgLTAuMDUsMC4wOTcgbCAtMzA0LjM2OCw1MjguNDEgYyAtMy44NjMsNi42NjUgLTUuNjUyLDkuMzA1IC05LjQwNiwxMy4wNTkgLTUuNzMsNS43MzEgLTEzLjI0Miw4LjU5OCAtMjAuNzU0LDguNTk4IHoiIC8+PHBhdGgKICAgICAgICAgaWQ9InBhdGg1NTAyIgogICAgICAgICBzdHlsZT0iZmlsbDojYzExMjFjO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpub25lIgogICAgICAgICBkPSJtIDMzOC44NjcsNTg3LjE0NCBjIC03LjEyNSwwLjA1MSAtMTQuOTQ5LC0zLjU5IC0xOC43ODEsLTEwLjQwNiBMIDEwLjc5Myw0MC44NDcgQyA5LjAwOCwzNy4xOTkgOC4yNTgsMzQuMDI3IDguMjM0LDMwLjM5OCBjIDAsLTYuNDk2IDIuODc1LC0xMi42NiA3Ljg0OCwtMTYuODQgNC4zODMsLTMuMzk0IDguNTM1LC01LjE2IDE0LjEyMSwtNS4xNiBsIDYxNy45MDYsMCBjIDMuNzcsLTAuMDM1IDcuNTQ3LDAuODcxIDEwLjk3NywzLjEzMyA2LjQ1MywzLjg5OCAxMC40MDIsMTAuODgzIDEwLjQxLDE4LjQyNiAtMC4xODQsMy44OTQgLTEuMTQ0LDggLTIuODc5LDEwLjg5IEwgMzU3LjUwNCw1NzYuODI4IGMgLTAuMDI3LDAuMDQ3IC0wLjA1OSwwLjA5NCAtMC4wOSwwLjE0IC0wLjAzMSwwLjA0NyAtMC4wNjIsMC4wOTQgLTAuMDk0LDAuMTQ1IC0xLjA5NywxLjc1NCAtMi40NzIsMy4zMDUgLTQuMDM5LDQuNjMzIC0zLjU5LDMuMTA5IC04LjA4Niw0Ljk3NiAtMTIuODI0LDUuMzE2IC0wLjUzMSwwLjA0NyAtMS4wNjIsMC4wNzggLTEuNTksMC4wODIgeiBNIDMwLjIwMyw4LjM5OCBsIC0xLjUyMywwIDEuNTU0LDAgLTAuMDMxLDAgeiBNIDMzOC41NDcsNDgwLjkzMyA1NzQuMjUsNzIuMzk4IGwgLTQ3MS43MzgsMCAyMzYuMDM1LDQwOC41MzUgeiIgLz48cGF0aAogICAgICAgICBpZD0icGF0aDU1MDQiCiAgICAgICAgIHN0eWxlPSJmaWxsOiMwMDAwMDA7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Im0gMzM4Ljg2Nyw1OTQuODk4IGMgLTcuNjE3LDAgLTE1LjIzLC0yLjkwNiAtMjEuMDM5LC04LjcxNSAtMS45MDYsLTEuOTAyIC0zLjQ5MiwtNC4wMDggLTQuNzczLC02LjIzNCBsIC0xNS4xMjksLTI1Ljk1NyAtMC4wNzEsMCBMIDQuNjQxLDQ1Ljc1NCBDIDQuNTc0LDQ1LjYzNiA0LjUyNyw0NS41MzUgNC40OCw0NS40NTMgMi45NzcsNDMuMDMxIDEuNzk3LDQwLjM1MSAxLjAyLDM3LjQ1NyAtMy4yMywyMS41ODYgNi4xOTEsNS4yNjkgMjIuMDU5LDEuMDE1IDI0LjY4LDAuMzEyIDI3LjMxNiwtMC4wMDggMjkuOTAyLDAgbCA2MTguMDY3LDAgYyAxNi40MjksMCAyOS43NTgsMTMuMzI4IDI5Ljc1OCwyOS43NTggMCw1LjM3NSAtMS40MzgsMTAuNDE3IC0zLjkzNCwxNC43NzMgLTAuMDEyLDAuMDE5IC0wLjAyNywwLjA1MSAtMC4wNTEsMC4wOTggTCAzNjkuMzc5LDU3My4wNDMgYyAtMy44NzEsNi42NjggLTUuNjk1LDkuMzYzIC05LjQ2OSwxMy4xNCAtNS44MDgsNS44MDkgLTEzLjQyNiw4LjcxNSAtMjEuMDM5LDguNzE1IGwgLTAuMDA0LDAgeiBtIDAsLTAuMzk4IGMgNy41MTIsMCAxNS4wMjQsLTIuODY3IDIwLjc1NCwtOC41OTggMy43NTQsLTMuNzU0IDUuNTQzLC02LjM5NCA5LjQwNiwtMTMuMDU5IEwgNjczLjM5MSw0NC40MzMgYyAwLjAxOSwtMC4wMzUgMC4wMzUsLTAuMDY2IDAuMDU0LC0wLjA5NyAyLjQ2NSwtNC4yOTcgMy44NzksLTkuMjc0IDMuODc5LC0xNC41NzggMCwtMTYuMjE1IC0xMy4xNCwtMjkuMzU2IC0yOS4zNTUsLTI5LjM1NiBsIC02MTguMDY3LDAgQyAyNy4zNDgsMC4zOSAyNC43NSwwLjcwNyAyMi4xNjQsMS40MDIgNi41MDQsNS41OTcgLTIuNzg5LDIxLjY5NSAxLjQwNiwzNy4zNTEgYyAwLjc2NiwyLjg2NyAxLjkzOCw1LjUxNiAzLjQyNiw3LjkxIDAuMDU1LDAuMDk4IDAuMDk4LDAuMTk2IDAuMTUyLDAuMjkzIGwgMjkzLjEwMiw1MDguMDM5IDAuMDcsMCAxNS4yNDYsMjYuMTU3IGMgMS4yNjIsMi4xOTkgMi44MjgsNC4yNzMgNC43MDcsNi4xNTIgNS43MzEsNS43MzEgMTMuMjQzLDguNTk4IDIwLjc1OCw4LjU5OCB6IiAvPjwvZz48L2c+PC9zdmc+",
          "width": 17,
          "height": 15,
          "dx": -8,
          "dy": -7
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 11,
        "to": 14,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 26,
          "height": 22,
          "dx": -13,
          "dy": -11
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 15,
        "to": 19,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 34,
          "height": 30,
          "dx": -17,
          "dy": -15
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      }
    ],
    "dangerous_situation": [
      {
        "from": 1,
        "to": 10,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 17,
          "height": 15,
          "dx": -8,
          "dy": -7
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 11,
        "to": 14,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 26,
          "height": 22,
          "dx": -13,
          "dy": -11
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 15,
        "to": 19,
        "image": {
          "url": "data:image/svg+xml;base64,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",
          "width": 34,
          "height": 30,
          "dx": -17,
          "dy": -15
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      }
    ],
    "highway": [
      {
        "from": 16,
        "to": 19,
        "line": {
          "color": "#f2d078",
          "width": 11,
          "outlineColor": "#ddac5e",
          "outlineWidth": 1
        },
        "image": {
          "url": "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+",
          "width": 33,
          "height": 20,
          "dx": -16,
          "dy": -13
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 13,
        "to": 15,
        "line": {
          "color": "#f2d078",
          "width": 7,
          "outlineColor": "#ddac5e",
          "outlineWidth": 1
        },
        "image": {
          "url": "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+",
          "width": 33,
          "height": 20,
          "dx": -16,
          "dy": -13
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 10,
        "to": 12,
        "line": {
          "color": "#f2d078",
          "width": 4,
          "outlineColor": "#ddac5e",
          "outlineWidth": 1
        },
        "image": {
          "url": "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+",
          "width": 33,
          "height": 20,
          "dx": -16,
          "dy": -13
        },
        "text": {
          "size": 11,
          "color": "white",
          "font": "Open Sans"
        }
      },
      {
        "from": 6,
        "to": 9,
        "line": {
          "color": "#f2d078",
          "width": 2
        }
      }
    ],
    "interstate_major": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 10,
          "color": "#f9e5a6",
          "outlineColor": "#e3d197",
          "outlineWidth": 1
        },
        "text": {
          "size": 14,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 7,
          "color": "#f9e5a6",
          "outlineColor": "#e3d197",
          "outlineWidth": 1
        },
        "text": {
          "size": 11,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 4,
          "color": "#f9e5a6",
          "outlineColor": "#e3d197",
          "outlineWidth": 1
        },
        "text": {
          "size": 11,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 10,
        "to": 12,
        "line": {
          "width": 1,
          "color": "#f9e5a6",
          "outlineColor": "#f0dc96",
          "outlineWidth": 1
        }
      },
      {
        "from": 9,
        "to": 9,
        "line": {
          "width": 2,
          "color": "#f9e5a6"
        }
      }
    ],
    "interstate_minor": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 10,
          "color": "#ffffff",
          "outlineColor": "#dddddd",
          "outlineWidth": 1
        },
        "text": {
          "size": 14,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 7,
          "color": "#ffffff",
          "outlineColor": "#dddddd",
          "outlineWidth": 1
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 4,
          "color": "#ffffff",
          "outlineColor": "#dddddd",
          "outlineWidth": 1
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "white",
          "outlineWidth": 2
        }
      },
      {
        "from": 10,
        "to": 12,
        "line": {
          "width": 1,
          "color": "#ffffff",
          "outlineColor": "#dddddd",
          "outlineWidth": 1
        }
      }
    ],
    "minor_road": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 7,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 3,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 1,
          "color": "#ffffff"
        }
      }
    ],
    "minor_road_oneway": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 7,
          "color": "#ffffff",
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9ImFycm93IiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAgNiIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEwIDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO308L3N0eWxlPjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjUuOSw1LjEgOS4xLDMgNS45LDAuOSIvPjxsaW5lIGNsYXNzPSJzdDAiIHgxPSI5LjEiIHkxPSIzIiB4Mj0iMC45IiB5Mj0iMyIvPjwvc3ZnPg==",
          "width": 10,
          "height": 6,
          "dx": -5,
          "dy": -3,
          "direction": "forward"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 3,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 1,
          "color": "#ffffff"
        }
      }
    ],
    "minor_road_oneway_reverse": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 7,
          "color": "#ffffff",
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9ImFycm93IiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAgNiIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEwIDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO308L3N0eWxlPjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjUuOSw1LjEgOS4xLDMgNS45LDAuOSIvPjxsaW5lIGNsYXNzPSJzdDAiIHgxPSI5LjEiIHkxPSIzIiB4Mj0iMC45IiB5Mj0iMyIvPjwvc3ZnPg==",
          "width": 10,
          "height": 6,
          "dx": -5,
          "dy": -3,
          "direction": "reverse"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 3,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 1,
          "color": "#ffffff"
        }
      }
    ],
    "minor_road_restricted": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 4,
          "color": "#cccccc"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans"
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 1,
          "color": "#cccccc"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans"
        }
      },
      {
        "from": 13,
        "to": 14,
        "line": {
          "width": 1,
          "color": "#cccccc"
        }
      }
    ],
    "residential_road": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 2,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 1,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      }
    ],
    "residential_road_oneway": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 2,
          "color": "#ffffff",
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9ImFycm93IiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAgNiIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEwIDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO308L3N0eWxlPjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjUuOSw1LjEgOS4xLDMgNS45LDAuOSIvPjxsaW5lIGNsYXNzPSJzdDAiIHgxPSI5LjEiIHkxPSIzIiB4Mj0iMC45IiB5Mj0iMyIvPjwvc3ZnPg==",
          "width": 10,
          "height": 6,
          "dx": -5,
          "dy": -3,
          "direction": "forward"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 1,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      }
    ],
    "residential_road_oneway_rev": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 2,
          "color": "#ffffff",
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9ImFycm93IiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAgNiIgd2lkdGg9IjEwIiBoZWlnaHQ9IjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEwIDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO308L3N0eWxlPjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjUuOSw1LjEgOS4xLDMgNS45LDAuOSIvPjxsaW5lIGNsYXNzPSJzdDAiIHgxPSI5LjEiIHkxPSIzIiB4Mj0iMC45IiB5Mj0iMyIvPjwvc3ZnPg==",
          "width": 10,
          "height": 6,
          "dx": -5,
          "dy": -3,
          "direction": "reverse"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      },
      {
        "from": 15,
        "to": 16,
        "line": {
          "width": 1,
          "color": "#ffffff"
        },
        "text": {
          "size": 12,
          "color": "#606060",
          "font": "Open Sans",
          "outlineColor": "#ffffff",
          "outlineWidth": 2
        }
      }
    ],
    "rail": [
      {
        "from": 13,
        "to": 19,
        "line": {
          "width": 1,
          "color": "#d4d4d4"
        }
      }
    ],
    "ferry": [
      {
        "from": 17,
        "to": 19,
        "line": {
          "width": 5,
          "color": "#74a8e1"
        },
        "text": {
          "size": 11,
          "color": "#4F7499",
          "font": "Open Sans",
          "outlineColor": "#a3cef4",
          "outlineWidth": 2
        }
      },
      {
        "from": 14,
        "to": 16,
        "line": {
          "width": 3,
          "color": "#74a8e1"
        },
        "text": {
          "size": 11,
          "color": "#4F7499",
          "font": "Open Sans",
          "outlineColor": "#a3cef4",
          "outlineWidth": 2
        }
      },
      {
        "from": 10,
        "to": 13,
        "line": {
          "width": 2,
          "color": "#74a8e1"
        }
      }
    ],
    "interstateNumbers": [
      {
        "from": 11,
        "to": 19,
        "image": {
          "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkJ1bmRlc3N0cmFzc2UiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIwMCAxMjAiIHdpZHRoPSIyMDAiIGhlaWdodD0iMTIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMDAgMTIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0Y5REM4MTt9PC9zdHlsZT48cGF0aCBpZD0icmVjdDQiIGNsYXNzPSJzdDAiIGQ9Ik0yMi4zLDBoMTU1LjVDMTkwLDAsMjAwLDEwLDIwMCwyMi4zdjc1LjVjMCwxMi4zLTEwLDIyLjMtMjIuMywyMi4zSDIyLjNDMTAsMTIwLDAsMTEwLDAsOTcuOFYyMi4zIEMwLDEwLDEwLDAsMjIuMywweiIvPjxwYXRoIGlkPSJyZWN0NiIgZD0iTTIyLjMsNC4zaDE1NS41YzkuOSwwLDE4LDguMSwxOCwxOHY3NS41YzAsOS45LTguMSwxOC0xOCwxOEgyMi4zYy05LjksMC0xOC04LjEtMTgtMThWMjIuMyBDNC4zLDEyLjMsMTIuMyw0LjMsMjIuMyw0LjN6Ii8+PHBhdGggaWQ9InJlY3Q4IiBjbGFzcz0ic3QwIiBkPSJNMjIuMywxMS4zaDE1NS41YzYuMSwwLDExLDQuOSwxMSwxMXY3NS41YzAsNi4xLTQuOSwxMS0xMSwxMUgyMi4zYy02LjEsMC0xMS00LjktMTEtMTFWMjIuMyBDMTEuMywxNi4yLDE2LjIsMTEuMywyMi4zLDExLjN6Ii8+PC9zdmc+",
          "width": 27,
          "height": 17,
          "dx": -14,
          "dy": -12
        },
        "text": {
          "size": 11,
          "color": "black",
          "font": "Open Sans"
        }
      }
    ]
  }
};
*/
module.exports = IWStreetsPostProcessor;
